<template>
  <div
    class="band"
    :class="{ pushFooter: showFooter }"
  >
    <div class="bandContent mainPage dontPadExtra">
      <router-view />
    </div>
  </div>
</template>

<script>

import { mapState, mapGetters, mapActions } from 'vuex'
import * as types from '../store/mutation-types'
import * as messageTypes from '../constants/message-types'
import NEWS_ITEMS from '../constants/news-items'
import { hasLocalState, PIN_NAV_PANEL } from '../utils/local-storage.js'

export default {
  name: 'StandardFrame',
  computed: {
    ...mapState({
      gotRepos: state => state.repos.gotRepos,
      allRepos: state => state.repos.allRepos,
      currentRepoId: state => state.repos.currentRepoId,
      showFooter: state => state.appFrame.showFooter,
      latestVersionUpdateSeen: state => state.status.latestVersionUpdateSeen,
      latestVersionUpdate: state => state.status.latestVersionUpdate,
      showLatestUpdate: state => state.status.showLatestUpdate,
    }),
    ...mapGetters([
      'currentRepo',
      'getDocument',
    ]),
  },
  watch: {
    '$route' (to, from) {
      if (to.params.repoId !== from.params.repoId) {
        this.setRepoId({ repoId: +to.params.repoId })
      }
      const main = this.getDocument.getElementById('main')
      main.scrollTop = 0
      main.scrollLeft = 0
    },
    latestVersionUpdateSeen (to, from) {
      if (this.latestVersionUpdateSeen !== this.latestVersionUpdate) {
        this.$store.commit(types.SHOW_LATEST_UPDATE, true)
      } else {
        this.$store.commit(types.SHOW_LATEST_UPDATE, false)
      }
      this.setupFrame()
    },
    latestVersionUpdate (to, from) {
      if (this.latestVersionUpdateSeen !== this.latestVersionUpdate) {
        this.$store.commit(types.SHOW_LATEST_UPDATE, true)
      } else {
        this.$store.commit(types.SHOW_LATEST_UPDATE, false)
      }
      this.setupFrame()
    },
    gotRepos: function (value) {
      this.$store.commit(types.SET_STATUS_MESSAGE, null)
      if (value) {
        if (this.allRepos.length === 0) {
          this.$store.commit(types.SET_GOT_REPOS, false)
          this.$router.replace({ name: 'error', params: { errorId: 'norepos' } })
        } else if (!this.currentRepoId) {
          this.setFirstRepoCurrent()
          if (this.allRepos.length > 1 && !hasLocalState(PIN_NAV_PANEL)) {
            this.$store.commit(types.SET_PIN_NAV_PANEL, true)
          }
        }
      }
    },
    currentRepoId: function (value) {
      const currentRoute = this.$router.currentRoute
      if (value === undefined) {
        this.$router.replace({ name: 'error', params: { errorId: 'norepochosen' } })
      } else if (+currentRoute.params.repoId !== +value) {
        this.$router.replace({ name: currentRoute.name, params: { repoId: value } })
      }
      this.setupFrame()
    },
  },
  created: function () {
    const desiredRepoId = this.$route.params ? +this.$route.params.repoId : undefined
    if (!this.gotRepos) {
      this.$store.dispatch('getAllRepos', desiredRepoId)
      this.$store.commit(types.SET_STATUS_MESSAGE, { type: messageTypes.ACTIVITY_MESSAGE, message: 'Getting Repos' })
    } else if (this.currentRepoId === undefined && desiredRepoId === -1) {
      this.setFirstRepoCurrent()
    } else {
      if (desiredRepoId) {
        this.setRepoId({ repoId: +desiredRepoId })
      }
      this.setupFrame()
    }
    this.$store.commit(types.SET_SHOW_FOOTER, true)
    this.$store.commit(types.SET_LATEST_VERSION_UPDATE, NEWS_ITEMS[NEWS_ITEMS.length - 1].release)
    // Compare the latest version update seen with the latest available

    if (this.latestVersionUpdateSeen !== this.latestVersionUpdate) {
      this.$store.commit(types.SHOW_LATEST_UPDATE, true)
    } else {
      this.$store.commit(types.SHOW_LATEST_UPDATE, false)
    }
  },
  methods: {
    ...mapActions([
      'setRepoId',
      'setFirstRepoCurrent',
    ]),
    setupFrame: function () {
      if (this.currentRepoId) {
        this.$store.commit(types.SET_SHRINK_HEADER, true)

        var menuItems = [
          {
            label: 'Packages',
            routeName: 'packages',
            routeParams: { repoId: this.currentRepoId },
          },
          {
            label: 'Activity',
            routeName: 'activity',
            routeParams: { repoId: this.currentRepoId },
          },
          {
            label: 'Setup',
            routeName: 'overview',
            routeParams: { repoId: this.currentRepoId },
          },
        ]

        if (this.showLatestUpdate) {
          menuItems.push({
            label: 'What\'s New',
            labelExtra: ' <span style="color: #e66941; font-size: 12px;">' + NEWS_ITEMS[NEWS_ITEMS.length - 1].header + '</span>',
            routeName: 'whatsNew',
            routeParams: { repoId: this.currentRepoId },
          })
        } else {
          menuItems.push({
            label: 'What\'s New',
            routeName: 'whatsNew',
            routeParams: { repoId: this.currentRepoId },
          })
        }

        this.$store.commit(types.SET_MENU_ITEMS, { menuItems: menuItems })
        this.$store.commit(types.SET_NAV_TOGGLER_AS_NEEDED, false)
        this.$store.commit(types.SET_HEADER_TITLE, this.currentRepo.name)
      }
    },
  },
}

</script>
